<template>
  <div id="appNav">
    <nav class="navbar navbar-expand-lg fixed-top" :class="{ 'scrolled': isScrolled }">
      <div class="container">
        <a class="navbar-brand" href="#hero">
          <img src="../assets/images/logo.png" height="70" alt="Sankoree Logo" loading="lazy" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon">
            <i class="fas" :class="isMenuOpen ? 'fa-times' : 'fa-bars'"></i>
          </span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/', hash: '#hero' }" @click.native="closeMenu">HOME</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/', hash: '#about' }" @click.native="closeMenu">ABOUT</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/', hash: '#theInstitute' }" @click.native="closeMenu">THE INSTITUTE</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link highlight" to="/SIGN/DC/2026" @click.native="closeMenu">SIGN DC 2026</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/', hash: '#contact' }" @click.native="closeMenu">CONTACT</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isScrolled: false,
      isMenuOpen: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // Initial check
    
    // Listen for bootstrap collapse events
    $('#navbarSupportedContent').on('show.bs.collapse', () => {
      this.isMenuOpen = true;
      document.body.style.overflow = 'hidden';
    });
    $('#navbarSupportedContent').on('hide.bs.collapse', () => {
      this.isMenuOpen = false;
      document.body.style.overflow = 'auto';
    });
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    },
    closeMenu() {
      $('#navbarSupportedContent').collapse('hide');
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.style.overflow = 'auto'; // Reset on destroy
  }
};
</script>

<style scoped>
.navbar {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 20px 0;
  background-color: transparent;
  border-bottom: 1px solid transparent;
}

.navbar.scrolled {
  padding: 10px 0;
  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(196, 5, 5, 0.1);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.05);
}

.navbar-brand img {
  transition: height 0.4s ease;
}

.scrolled .navbar-brand img {
  height: 55px;
}

.navbar-nav .nav-item {
  margin-left: 25px;
}

.navbar-nav .nav-link {
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 1px;
  color: #333;
  padding: 10px 15px !important;
  position: relative;
  transition: color 0.3s ease;
}

.navbar-nav .nav-link::after {
  content: '';
  position: absolute;
  bottom: 5px;
  left: 15px;
  right: 15px;
  height: 2px;
  background-color: #c40505;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.navbar-nav .nav-link:hover {
  color: #c40505;
}

.navbar-nav .nav-link:hover::after {
  transform: scaleX(1);
}

.nav-link.highlight {
  background-color: #c40505;
  color: white !important;
  border-radius: 4px;
  padding: 8px 20px !important;
  margin-top: 2px;
}

.nav-link.highlight::after {
  display: none;
}

.nav-link.highlight:hover {
  background-color: #a00404;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(196, 5, 5, 0.2);
}

.navbar-toggler {
  border: none;
  padding: 10px;
  outline: none !important;
}

.fa-bars, .fa-times {
  color: #c40505;
  font-size: 1.5rem;
}

@media (max-width: 991.98px) {
  .navbar-collapse {
    background: white;
    margin-top: 15px;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    width: 100%;
  }
  
  .navbar.scrolled .navbar-collapse {
    background: rgba(255, 255, 255, 0.95);
  }

  .navbar, .navbar.scrolled {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .navbar-nav .nav-item {
    margin: 5px 0;
  }
}
</style>
